import { styled } from "styled-components";
export const Margin = styled.div`
  margin-right: 460px;
`;
